import React, { useState, useRef, useEffect } from "react";
import Logo from "../../assets/images/Yogify.png";
import { GiPrayerBeads } from "react-icons/gi";
import { RiSecurePaymentLine } from "react-icons/ri";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import LoginBanner from '../../assets/images/login.jpg'
const Otp = () => {
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [countdown, setCountdown] = useState(300); // 5 minutes in seconds
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const inputRefs = useRef([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
    
    // Start countdown timer on component mount
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setIsResendDisabled(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (isNaN(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value.substring(value.length - 1);
    setOtp(newOtp);

    if (value && index < 5 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleResendOtp = () => {
    // Reset countdown to 5 minutes
    setCountdown(300);
    setIsResendDisabled(true);
    
    // Start countdown timer again
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setIsResendDisabled(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    
    // Add your OTP resend logic here
    console.log("Resending OTP...");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const enteredOtp = otp.join("");
    const storedOtp = localStorage.getItem('otp'); // Retrieve OTP from localStorage
    if (enteredOtp.length < 6) {
      toast.error("Please enter a 6-digit OTP");
      return;
    }
    if (enteredOtp !== storedOtp) {
      toast.error("Invalid OTP. Please try again.");
      return;
    }
    toast.success("OTP verified successfully!");
    navigate('/auth/changepassword');

    // Add your OTP verification logic here
  };

  // Format countdown to MM:SS
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div id="Otp">
      <div className="container">
        <div className="LoginMain">
          <div className="LoginBox">
            <div className="LoginLeftBox">
              {/* <div className="LoginLogo">
                <img src={Logo} alt="Yogify Logo" />
              </div>
              <div className="LoginTitle">
                <h2>Authentic Spiritual Essentials to Help You Connect with Your True Self</h2>
              </div>
              <div className="ProductSecureBox">
                <div className="SecureBox">
                  <div className="IconBox">
                    <GiPrayerBeads className="SecureIcon" />
                  </div>
                  <div className="SecureTitle">
                    <p>Soulful Accessories</p>
                  </div>
                  <div className="SecureDescription">
                    <p>Crafted with Trusted Spiritual Quality</p>
                  </div>
                </div>

                <div className="SecureBox">
                  <div className="IconBox">
                    <RiSecurePaymentLine className="SecureIcon" />
                  </div>
                  <div className="SecureTitle">
                    <p>Secure Checkout</p>
                  </div>
                  <div className="SecureDescription">
                    <p>Multiple Payment Options — Fast, Safe & Secure</p>
                  </div>
                </div>
              </div> */}
             <img src={LoginBanner} alt="" />
              
            </div>
            <div className="LoginRightBox">
              <div className="Title">
                <h2>OTP Verification</h2>
                <p>We've sent a verification code to your mobile number</p>
              </div>

              <div className="LoginFormGroup">
               <form onSubmit={handleSubmit}>
                  <div className="OtpBox">
                    {otp.map((digit, index) => (
                      <input
                        key={index}
                        type="text"
                        value={digit}
                        ref={(el) => (inputRefs.current[index] = el)}
                        onChange={(e) => handleChange(e, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        maxLength={1}
                        className={`OtpInput ${digit ? "filled" : ""}`}
                      />
                    ))}
                  </div>
                  <div className="ResendOtp">
                    <p>Didn't receive code?</p>
                    {countdown > 0 ? (
                      <span className="Countdown">Resend in {formatTime(countdown)}</span>
                    ) : (
                      <button 
                        type="button" 
                        onClick={handleResendOtp}
                        className="ResendButton"
                        disabled={isResendDisabled}
                      >
                        Resend OTP
                      </button>
                    )}
                  </div>
                  <div className="LoginBtn">
                    <button type="submit">Verify OTP</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Otp;